import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main>
      <section className="phero">
        <div className="phero-inner">
          <p className="eyebrow">Błąd 404</p>
          <h1>Tej strony u nas nie ma</h1>
          <p className="lead">
            Adres mógł się zmienić albo zawiera literówkę. Poniżej najczęściej odwiedzane
            miejsca w serwisie.
          </p>
        </div>
      </section>

      <section className="sec">
        <div className="wrap">
          <div className="grid-3">
            <Link className="tile" to="/cennik" style={{ textDecoration: "none" }}>
              <h3>Cennik</h3>
              <p>Stałe ceny opinii i dokumentów wraz z terminami realizacji.</p>
            </Link>
            <Link className="tile" to="/jak-to-dziala" style={{ textDecoration: "none" }}>
              <h3>Jak to działa</h3>
              <p>Przebieg sprawy krok po kroku — od opisu do podpisanego PDF-a.</p>
            </Link>
            <Link className="tile" to="/baza-wiedzy" style={{ textDecoration: "none" }}>
              <h3>Baza wiedzy</h3>
              <p>Praktyczne wyjaśnienia przygotowane przez radców prawnych.</p>
            </Link>
          </div>
          <div className="cluster mt-l">
            <Link to="/" className="btn wax">
              Wróć na stronę główną
            </Link>
            <Link to="/kontakt" className="btn ghost">
              Napisz do nas
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
